import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userService } from '../services/user.service';
import type { TenantUser, FronteggRole } from '../services/user.service';

export function useTenantUsers(options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<TenantUser[]>({
    queryKey: ['tenantUsers'],
    queryFn: () => userService.listTenantUsers(),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes - users change infrequently
  });
}

export function useAvailableRoles() {
  return useQuery<FronteggRole[]>({
    queryKey: ['availableRoles'],
    queryFn: () => userService.listRoles(),
    staleTime: 30 * 60 * 1000, // 30 minutes - roles rarely change
  });
}

export function useUpdateUserRoles() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, roleIds }: { userId: string; roleIds: string[] }) =>
      userService.updateUserRoles(userId, roleIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenantUsers'] });
    },
  });
}
